import {
  RTCStreamSingleton,
  WSConnectionSingleton,
  mainConnection,
} from '../socket';
import { endpointMatch } from '../util';
import { eventViewerStore } from '../store';
const rS = RTCStreamSingleton.getConnection();
const tC = WSConnectionSingleton.getConnection();

class EventViewerApi {
  getLogNames(serviceInstanceId: string) {
    mainConnection.send('GetEventLogNames', serviceInstanceId || '');
  }

  getRecordDetails(
    serviceInstanceId: string,
    logName: string,
    recordId: number,
  ) {
    mainConnection.send('GetRecordDetails', [
      serviceInstanceId || '',
      logName,
      recordId,
    ]);
  }

  sendEventViewerQuery(eventQuery: EventQuery) {
    mainConnection.send('QueryEventViewer', eventQuery);
  }
}

export const eventViewerApi = new EventViewerApi();

mainConnection.listenKeys(endpointMatch, {
  queryEventViewer(queryResult: EventViewerQueryResult) {
    eventViewerStore.setQueryResult(queryResult);
  },
  getEventLogNames(payload: { serviceId: string; logNames: string[] }) {
    eventViewerStore.serviceId = payload.serviceId;
    eventViewerStore.setLogNames(payload.logNames);
  },
  getRecordDetails(payload: { serviceId: string; eventRecord: EventRecord }) {
    eventViewerStore.serviceId = payload.serviceId;
    eventViewerStore.setSelectedRecord(payload.eventRecord);
  },
});

rS.listenKeys(endpointMatch, {
  queryEventViewer(queryResult: EventViewerQueryResult) {
    eventViewerStore.setQueryResult(queryResult);
  },
  getEventLogNames(payload: { serviceId: string; logNames: string[] }) {
    eventViewerStore.serviceId = payload.serviceId;
    eventViewerStore.setLogNames(payload.logNames);
  },
  getRecordDetails(eventRecord: EventRecord) {
    eventViewerStore.setSelectedRecord(eventRecord);
  },
});
